import { render, staticRenderFns } from "./userLiveness.vue?vue&type=template&id=ab02b17e&scoped=true"
import script from "./userLiveness.vue?vue&type=script&lang=js"
export * from "./userLiveness.vue?vue&type=script&lang=js"
import style0 from "./userLiveness.vue?vue&type=style&index=0&id=ab02b17e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab02b17e",
  null
  
)

export default component.exports